export default __webpack_public_path__ + "static/media/home-tablet.27bce983.jpg";